import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceProduct($id: ID!, $shop: Int!) {
    marketplaceProduct: marketplaceProductByVariantGroupCode(
      id: $id
      shop: $shop
    ) {
      id
      title
      description
      careInstructions
      returnable
      warranty
      brand
      category {
        path {
          code
          title
        }
      }
      options {
        id
        type
        displayName
        visualGuide {
          name
          url
          description
        }
        values {
          id
          label
        }
      }
      variants {
        id
        title
        originalPrice
        discountPrice
        sku
        quantity
        images {
          url
          description
        }
        optionValues {
          id
          optionId
          value
          displayName
        }
      }
      info {
        id
        label
        value
      }
    }
    marketplaceShop(id: $shop) {
      id
      name
      retailer {
        sys {
          id
        }
        title
        retailerLogoSet {
          coloured {
            url
          }
        }
      }
    }
  }
`
